import UserPrepaidCardApi from '@apis/prepaid/UserPrepaidCardApi';
import Button from '@components/Button';
import Column from '@components/Column';
import Text from '@components/Text';
import useModal from '@hooks/ui/useModal';
import useToast from '@hooks/ui/useToast';
import { ErrorResponse } from '@models/error';
import { AxiosError } from 'axios';
import { MouseEvent } from 'react';

interface Props {
    id: string;
    balance: number;
}

function useDeletePrepaidCard({ id, balance }: Props) {
  const { openModal, closeModal } = useModal();
  const toast = useToast();
  const deletePrepaidCard = () => {
    closeModal();
    UserPrepaidCardApi.deletePrepaidCard(id)
      .then(() => {
        toast.info('선불카드가 삭제되었습니다.');
      }).catch((e: AxiosError<ErrorResponse>) => {
        toast.error(e.response?.data.message || '오류가 발생하였습니다.');
      });
  };
  const handleDelete = (e: MouseEvent<HTMLOrSVGElement>) => {
    e.preventDefault();
    e.stopPropagation();
    if (balance !== 0) {
      toast.error('잔액이 남아있는 선불카드는 삭제할 수 없습니다.');
      return;
    }
    openModal(<Column align='center' spacing={36} fullWidth>
            <Text align='center' size='xl'>
                해당 선불카드를 삭제할까요?
            </Text>
            <Column fullWidth spacing={10}>
                <Button variant='secondary'
                        fullWidth
                        onClick={closeModal}>
                    취소
                </Button>
                <Button fullWidth onClick={deletePrepaidCard}>
                    삭제하기
                </Button>
            </Column>
        </Column>);
  };

  return { handleDelete };
}

export default useDeletePrepaidCard;
